import styles from './sliderControls.module.css'

const SliderControls = () => {
  return (
    <div className={styles.controls}>
      <button className={styles.selected}></button>
      <button></button>
      <button></button>
      <button></button>
    </div>
  )
}

export default SliderControls
